import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

import { licenceCheckRequest } from "../../store/actions/usersActions";

import "./styles.scss";

const NewDash = () => {
  const [loading, setLoading] = useState(true);
  const [iframeHeight, setIframeHeight] = useState(2000);
  const iframeRef = useRef(null);

  const updateHeight = () => {
    try {
      const height = iframeRef.current?.contentDocument?.documentElement?.scrollHeight;
      if (height) setIframeHeight(height);
    } catch {
      // cross-origin blocked, fallback stays
    }
  };

  useEffect(() => {
    const observer = new ResizeObserver(updateHeight);
    const iframe = iframeRef.current;

    const onLoad = () => {
      updateHeight();
      // Observe inner body for dynamic content changes
      const innerBody = iframe?.contentDocument?.body;
      if (innerBody) observer.observe(innerBody);
    };

    iframe?.addEventListener('load', onLoad);
    return () => {
      iframe?.removeEventListener('load', onLoad);
      observer.disconnect();
    };
  }, []);

  return (
  <div className={`newdash-container ${loading ? "newdash-container--loading" : ""}`}>
    {loading && <div className="newdash-container__loader"></div>}
    <iframe
      ref={iframeRef}
      src="/mdash"
      className="newdash-container__iframe"
      title="MDash App"
      scrolling="no"
      style={{ height: `${iframeHeight-10}px` }}
      onLoad={() => setLoading(false)}
    />
  </div>
); 
};

export default NewDash;